export default __webpack_public_path__ + "static/media/botnet.f598f9f5.jpg";